// extracted by mini-css-extract-plugin
export default {"button":"Wj-z","reviewSort":"Xj-z"};